<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search Email..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="transactionData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'btn'">
                      <b-button pill variant="primary" size="sm" v-b-modal.modal-1 @click="setModalData(props.row)">View Details</b-button>
                      <div v-if="props.row.slot_available != 0">
                        <b-button pill size="sm" v-b-modal.modal-donasi @click="setModalDonasi(props.row)">Donasikan</b-button>
                      </div>
                      <div v-else class="align-content-center">
                        <b-button pill size="sm" v-b-modal.modal-donasi disabled>Tidak dapat di Donasikan</b-button>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <b-modal id="modal-1" title="Detail Donasi" button-size="sm">
                <div v-if="donationHistory.length == 0">
                  Belum didonasikan
                </div>
                <div v-else>
                  <b-table striped hover :items="donationHistory">
                    <template #cell(id)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                </template>
              </b-modal>
              <b-modal id="modal-donasi" title="Donasi" button-size="sm">
                <label for="user">Pilih User:</label>
                <multiselect id="user" v-model="selectedUser"
                             :options="userData"
                             track-by="id"
                             label="email"
                             name="user"
                             placeholder="Cari User"
                             :internal-search="false"
                             @search-change="getUserData">
                  <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> ({{ option.email }})</template>
                </multiselect>
                <div v-if="Object.keys(selectedUser).length !== 0">
                  <p>
                    Nama: {{ selectedUser.name }}<br>
                    Email: {{ selectedUser.email }}<br>
                    Paket: {{ activeDonation.product_name }} - {{ activeDonation.month }} Bulan<br>
                  </p>
                </div>
                <template #modal-footer="{ cancel, ok }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                  <b-button variant="primary" size="sm" @click="donateToUser(selectedUser, activeDonation)">
                    Submit
                  </b-button>
                </template>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import Stat from "@/components/widgets/stat";
export default {
  name: "donatur",
  page: {
    title: "Donatur",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Multiselect, Layout, PageHeader, Stat},
  created() {
    this.fetchTransactionData()
  },
  data() {
    return {
      title: "Donatur",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      payload_donation: {
        transaction_id: 0,
        account_id: 0
      },
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      selectedUser: {},
      transactionData: [],
      columns: [
        { field: "invoice_number", label: "No Invoice" },
        { field: "account_name", label: "Nama Donatur" },
        { field: "account_email", label: "Email Donatur" },
        { field: "transaction_time", label: "Tanggal Transaksi" },
        { field: "product_name", label: "Type Donasi" },
        { field: "slot_donation", label: "Slot Donasi" },
        { field: "slot_available", label: "Slot Tersedia" },
        { field: "btn", label: "Action" },
      ],
      activeDonation: {},
      donationHistory: [],
      userData: [],
      statData: [
        {
          icon: "bx bx-archive-in",
          title: "Total Slot",
          value: "0"
        },
        {
          icon: "bx bx-archive-out",
          title: "Slot Tersedia",
          value: "0"
        }
      ],
    }
  },
  computed: {

  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    getUserData(query) {
      let params = queryString.stringify({
        page: 1,
        limit: 100,
        email: query
      })
      axios.get("/api/account?"+params)
          .then(resp => {
            const { data } = resp.data
            this.userData = data
          });
    },
    getReportData() {
      axios.get("/api/transaction/donation/report")
          .then(resp => {
            const { data } = resp.data
            this.statData[0].value = data.slot_donation.toString()
            this.statData[1].value = data.slot_available.toString()
          });
    },
    setModalDonasi(rowData) {
      this.activeDonation = rowData
      this.selectedUser = {}
    },
    setModalData(rowData) {
      this.activeDonation = rowData
      const donationHistory = rowData.donation_history.map(x => {
        return {
          id: x.id,
          tgl_donasi: x.created_date,
          nama_akun: x.account.name,
          email: x.account.email,
          membership_expired_date: x.account.membership_expired_date,
        }
      })
      this.donationHistory = donationHistory
    },
    fetchTransactionData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallTransactionData(params)
    },
    httpCallTransactionData(params) {
      axios.get("/api/transaction/donation?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.transactionData = data
            this.isFetched = true
          });
    },
    donateToUser(selectedUser, activeDonation) {
      if (Object.keys(selectedUser).length === 0) {
        Swal.fire('Pilih user terlebih dahulu')
        return
      }
      const request = {
        account_id: selectedUser.id,
        transaction_id: activeDonation.transaction_id,
      }
      axios.post("/api/historical_membership?", request)
          .then(resp => {
            Swal.fire('Sukses')
            this.$bvModal.hide('modal-donasi')
            this.$router.go()
          }).catch(resp => {
            Swal.fire('Internal Server Error')
      });
    }
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        email: value,
        sort: '-id',
      })
      this.httpCallTransactionData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          email: this.searchText,
          sort: '-id',
        })
        this.httpCallTransactionData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          email: this.searchText,
          sort: '-id',
        })
        this.httpCallTransactionData(params)
      }
    },
  },
  mounted() {
    this.getReportData()
  }
}
</script>

<style scoped>

</style>